import {api} from "@/api/setup";
import router from "@/router";


let USER_LOGGED_IN = false;


function persistToken(token: string) {
    localStorage.setItem('user_token', token);
}

export function getToken(): string|null {
    return localStorage.getItem('user_token');
}

export function isLogged() {
    if (USER_LOGGED_IN) {
        return true;
    }
    if (getToken()) {
        USER_LOGGED_IN = true;
    }
    return USER_LOGGED_IN;
}

export function logout() {
    USER_LOGGED_IN = false;
    persistToken('');
    router.push({ path: '/login'});
}

export async function login(username: string, password: string): Promise<boolean> {
    const request = new Request(api(`/login`), {
        method: 'POST',
        mode: 'cors',
        redirect: 'follow',
        headers: new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify({username, password})
    });
    const response = await fetch(request);
    const data: { success: string; token: string; } = await response.json();
    if (data.token) {
        persistToken(data.token);
    }
    USER_LOGGED_IN = !!data.token;
    return USER_LOGGED_IN;
}


export function loginRequired() {
    return (to: any, from: any, next: any) => {
        if (isLogged()) {
            return next();
        }
        router.push({ path: '/login'})
    }
};
